import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';

import Avatar from 'components/Avatar';

import {MODALS, openModal} from 'ducks/modals';
import {fetchMemberCheckInInfo} from 'ducks/frontDesk';

import takePhotoImage from 'assets/icons/takePhoto.svg';

import './styles.css';

class TakePhotoCard extends React.Component<any> {
  openTakePhotoModal = () => {
    const agreementUserId = this.props.tenant.id;
    const {locationRef, bookingId} = this.props;

    const extraActions = [
      () =>
        fetchMemberCheckInInfo(
          {locationRef, bookingId},
          this.props.fetchMemberCheckInInfoExtraActions()
        ),
      ...this.props.fetchArrivalsExtraActions()
    ];

    this.props.openModal(MODALS.AGREEMENT_USER_TAKE_PHOTO, {
      locationRef,
      agreementUserId,
      extraActions
    });
  };

  render() {
    const {tenant} = this.props;
    return (
      <div className="TakePhotoCard">
        <Avatar
          className="TakePhotoCard__Avatar"
          url={tenant.internalAvatarCropped || tenant.avatarCropped}
          initials={tenant.initials}
        />
        <div
          className="TakePhotoCard__circle"
          onClick={this.openTakePhotoModal}>
          <img
            src={takePhotoImage}
            className="TakePhotoCard__circle__image"
            alt="Take Photo"
          />
          <div className="TakePhotoCard__circle__text">Take photo</div>
        </div>

        <div className="TakePhotoCard__tenant">
          <div className="TakePhotoCard__tenant__name">{tenant.fullName}</div>
          <div className="TakePhotoCard__tenant__email">{tenant.email}</div>
          <div className="TakePhotoCard__tenant__phone">
            {tenant.phoneNumber || 'No phone available'}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchMemberCheckInInfo,
  openModal
};
export default connect(null, mapDispatchToProps)(TakePhotoCard);
